<template>
    <div class="list-item" :class="['padding-' + padding]" data-growing-container data-growing-circle>
        <slot>
            <div class="clearfix" data-growing-container data-growing-circle>
                <div class="list-item-left">
                    <slot name="left"></slot>
                </div>
                <div class="list-item-right">
                    <slot name="right"></slot>
                </div>
                <slot name="content"></slot>
            </div>
        </slot>
        <slot name="extra"></slot>
    </div>
</template>
<script>
/**
 * 支持slot=default slot=left slot=right slot=content，当default存在时，其他3个将失效
 */
export default {
    name: 'ListItem',
    props: {
        /**
         * 边距样式 normal/small
         */
        padding: {
            type: String,
            default: 'normal',
        },
    },
};
</script>
<style lang="less">
@import "../../lib/style/mixins.less";

.list-item {
    position: relative;
    padding: @list-padding-v @list-padding-h;
    font-size: @list-font-size;
    line-height: @list-line-height;
    // color: @color-black;
    &.padding-small {
        padding: 7 10px;
    }
    &.padding-large {
        padding: 12 14px;
    }

    .list-item-left {
        float: left;
        max-width: 60%;
    }
    .list-item-right {
        float: right;
    }
    .list-item-content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .list-item-content.right {
        text-align: right;
    }

    .list-item.placeholder {
        .list-item-right {
            color: @third-font-color;
        }
        select {
            color: @third-font-color;
            option {
                color: @third-font-color;
            }
        }
    }

    // 应用在input上
    .list-input {
        background-color: @color-transparent;
        border: 0;
        // 删除原本样式
        appearance: none;
        -webkit-appearance: none;
        box-sizing: border-box;
        &.block {
            width: 100%;
        }
        // 内容局右
        &.right {
            text-align: right;
            text-align-last: right;
            text-align: -webkit-right;
        }
        &.two {
            height: 44px;
        }
        &::-webkit-input-placeholder {
            color: @third-font-color;
        }
    }
    select.list-input.right {
        direction: rtl;
        option {
            text-align: right;
            text-align-last: right;
            text-align: -webkit-right;
        }
    }

    // textarea的样式
    .list-item-textarea {
        width: 100%;
        .text-normal();
        border: 0;
        vertical-align: middle;
        resize: none;
    }
    .list-item-textarea-length {
        text-align: right;
    }
    .list-required {
        color: @color-red;
    }
    // select的样式
    .list-item-placeholder-select {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        opacity: 0;
    }
}
</style>
